import type { Permissions } from '@/rbac/grants'
import type { Role } from '@/stores/auth'
import { demoApi } from './db'

interface LegacyRole extends Role {
	id: number
	name: string
}

export const rolesApi = {
	getRoles: async (_tenantId?: string): Promise<Role[]> => {
		const res = await demoApi.get<Role[] | { result: LegacyRole[] }>('/v1/roles')
		const list = Array.isArray(res) ? res : res.result
		return list
	},
	getRolesForOrganization: async (organizationId: string): Promise<Record<string, Role[]>> => {
		const res = await demoApi.getNoTenant<{
			roles: Array<{ tenant_id: string; name: string; permissions?: Permissions }>
		}>(`/v3/organizations/${encodeURIComponent(organizationId)}/roles`)

		const grouped: Record<string, Role[]> = {}
		for (const role of res.roles ?? []) {
			grouped[role.tenant_id] ??= []
			grouped[role.tenant_id].push({
				name: role.name,
				permissions: role.permissions,
			})
		}

		return grouped
	},

	createRole: async (role: { name: string; permissions: Permissions }): Promise<{ status: string; name: string }> => {
		const res = await demoApi.post<Role | { result: { name: string } }>('/v1/roles', role)
		if ('result' in res) {
			return { status: 'success', name: res.result.name }
		}
		return { status: 'success', name: (res as Role).name }
	},

	updateRole: async (role: string): Promise<{ status: string }> =>
		demoApi.put<{ status: string }>(`/v1/roles/${role}`, role),
	deleteRole: async (roleName: string): Promise<{ status: string }> =>
		demoApi.delete<{ status: string }>('/v1/roles', { name: roleName }),
}
